import React, { useState } from 'react';
import { GraduationCap, X } from 'lucide-react';

export default function EducationalBanner() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;

  return (
    <div className="relative bg-slate-900 text-white" data-testid="educational-banner">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 py-2 text-center text-xs sm:text-sm">
        <GraduationCap className="h-4 w-4 shrink-0 text-teal-400" />
        <span className="font-medium">
          This is a <strong className="text-teal-300">free, purely educational</strong> resource. All data is sourced from CDC, WHO, and peer-reviewed studies. Not a substitute for professional medical advice.
        </span>
        <button
          onClick={() => setVisible(false)}
          className="ml-2 shrink-0 rounded-full p-0.5 hover:bg-white/10 transition-colors"
          aria-label="Dismiss banner"
          data-testid="dismiss-educational-banner"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
    </div>
  );
}
